import { AxiosError } from 'axios';

export const isAxiosError = (_: unknown): _ is AxiosError => Object.getOwnPropertyNames(_).includes('isAxiosError');
